import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_getHeadlineCarousels, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_getHeadlineCarousels';
import { CarouselModeType } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';

export type HeadlineCarouselModelType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Array<HeadlineCarouselModelType> => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

interface ParamsType {
    carousel_type: CarouselModeType,
}

export const getHeadlineCarousel = {
    browser: {
        params: (params: ParamsType): ParamsFetchType<ParamsType> => {
            return {
                type: MethodType.GET,
                url: `/api-web/get-headline-carousel/${params.carousel_type}`,
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.GET,
        urlBrowser: '/api-web/get-headline-carousel/:carousel_type',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<ParamsType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }
        const response = await openapi_website_cms_getHeadlineCarousels(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            collection_slug: params.req.params.carousel_type
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
